import { render, staticRenderFns } from "./DriverHistoryStatus.vue?vue&type=template&id=64bce791"
import script from "./DriverHistoryStatus.vue?vue&type=script&lang=js"
export * from "./DriverHistoryStatus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports